import type { FC, ReactNode } from 'react'
import Badge from '@g4g/ui/src/components/Badge'
import { classNames } from '@g4g/utils/src/react/class-names'

const ProductBadge: FC<{ children?: ReactNode; color: 'blue' | 'purple'; heading?: boolean }> = ({
  children,
  color,
  heading,
}) => (
  <Badge
    classNames="px-1 py-0.5"
    wrapperClassNames={classNames(!heading && 'sr-only sm:not-sr-only', 'text-xs')}
    data-cy="shop-product-detail-badge"
    color={color}
  >
    {children}
  </Badge>
)

export default ProductBadge
